<template lang="html"> 
    <section class="wizard">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">Add New Menu</h4>
                        <vue-good-wizard :steps="steps" 
                                         :onNext="nextClicked" 
                                         :onBack="backClicked">
                            <div slot="page1">
                                <menu-edit-basic-info :menu="menu"/>
                            </div>
                            <div slot="page2">
                                <menu-edit-items-list :menu="menu"/>
                            </div>
                            <div slot="page3">
                                Press Save to save menu
                            </div>
                        </vue-good-wizard>
                    </div>
                </div>
            </div>
        </div> 
    </section>
</template> 

<script lang="js">
import { mapActions, mapState } from'vuex'
import { GoodWizard } from 'vue-good-wizard'
import MenuBaseForm from '../Bases/MenuBaseForm'
import MenuEditBasicInfo from './MenuEditBasicInfo'
import MenuEditItemsList from './MenuEditItemsList'
import ItemsSearch from '../../Items/ItemsSearch'
export default {
    name: 'menueditfrom',
    extends : MenuBaseForm,
    inject: ['eventBus'],
    components: {
        MenuEditBasicInfo,
        MenuEditItemsList,
        'vue-good-wizard': GoodWizard
    },
    created () {
        this.menu = this.$lodash.cloneDeep(this.$store.getters['menus/menuById'](this.$route.params.id));
        this.setAction('menus/updateMenuAction');
    }
}
</script>